import React from "react";

import { UniformPreviewPageProps } from "../../../../pages/uniform-preview/uniform-preview-page";
import { UniformWrapper } from "../../../../uniform/uniform-wrapper";

export const UniformPreviewPageTemplate: React.FC<UniformPreviewPageProps> = ({
    composition,
    isUniformPlayground
}) => {
    return (
        <UniformWrapper
            composition={composition}
            isUniformPlayground={isUniformPlayground}
        />
    );
};
